import React, { useState, useEffect } from "react";
import LoadingSpinner from "../../composant_reutilisable/loading";
import { motion, AnimatePresence } from "framer-motion";
import { useMediaQuery } from "react-responsive";
import { FaBoxOpen, FaLayerGroup, FaShip, FaWeightHanging } from "react-icons/fa";
import { FaRoadBarrier } from "react-icons/fa6";
import { BsCarFront } from "react-icons/bs";
import { useLocation, useParams } from 'react-router-dom';

const Liste_pays_destination = ({ titre }) => {
  const location = useLocation();
  const { nom_parc } = location.state || {}; // Obtention de le refrence du parc
  const { parc_ref } = useParams();
  const [camions, setCamions] = useState([]);
  const [camionsSortants, setCamionsSortants] = useState({
    nationaux: [],
    pays_destination: [],
    // bailleurs: [],
  });
  const [isLoading, setIsLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isPaused, setIsPaused] = useState(false); // ⬅️ état pause pour stopper le defilement des écrans
  // const [isMobileView, setIsMobileView] = useState(false);

  // Carrousel states
  const [currentPages, setCurrentPages] = useState({
    entrants: { nationaux: 0, pays_destination: 0 },
    sortants: { nationaux: 0, pays_destination: 0 }
  });

  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [pageDuration, setPageDuration] = useState(5);

  // Paramètres dynamiques
  const nbParPage = itemsPerPage || 5;
  const dureeAffichage = (pageDuration || 5) * 1000;

  const [parcs, setParcs] = useState([]);
  // Récupération de tous les parcs
  const fetchParcs = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(process.env.REACT_APP_HOTE + "/liste-parc/");
      if (response.ok) {
        const data = await response.json();
        setParcs(data);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des parcs:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Récupération de toutes les Catégories
  const [selectedCategorie, setSelectedCategorie] = useState(null); // null = pas de filtre
  const [allCategories, setAllCategories] = useState([]);
  const fetchCategories = async () => {
    try {
      setIsLoading(true);
      const response = await fetch(process.env.REACT_APP_HOTE + "/liste-categories/");
      if (response.ok) {
        const data = await response.json();
        setAllCategories(data);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des categories:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const isBeninois = (camion) => {
    // Vérifie chaque partie possible du camion
    const checkNationalite = (nationalite, code) => {
      return nationalite?.includes("Bénin") || code?.includes("BJ");
    };

    return (
      checkNationalite(camion.nationalite_tete, camion.code_nationalite_tete) ||
      checkNationalite(camion.nationalite_queue, camion.code_nationalite_queue) ||
      checkNationalite(camion.nationalite_non_articule, camion.code_nationalite_non_articule)
    );
  };

  // Camions entrants
  const camionsNationauxEntrants = camions.filter(isBeninois);
  const camionsPaysDestinationEntrants = camions.filter(camion => !isBeninois(camion));

  // Camions sortants
  const camionsNationauxSortants = camionsSortants.nationaux.filter(isBeninois);
  const camionsPaysDestinationSortants = camionsSortants.pays_destination.filter(camion => !isBeninois(camion));

  // Fonctions pour filtrer par catégorie
  const camionsNationauxEntrantsParCategorie = (categorie) =>
    camionsNationauxEntrants.filter(camion => camion.nom_categorie === categorie);

  const camionsPaysDestinationEntrantsParCategorie = (categorie) =>
    camionsPaysDestinationEntrants.filter(camion => camion.nom_categorie === categorie);

  const camionsNationauxSortantsParCategorie = (categorie) =>
    camionsNationauxSortants.filter(camion => camion.nom_categorie === categorie);

  const camionsPaysDestinationSortantsParCategorie = (categorie) =>
    camionsPaysDestinationSortants.filter(camion => camion.nom_categorie === categorie);


  // Camions entrants par catégorie avec recherche
  const filteredCamionsNationauxEntrants = (categorie) =>
    camionsNationauxEntrantsParCategorie(categorie).filter(camion =>
    (camion.tete?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      camion.queue?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      camion.immatriculation?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (camion.date_creation?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.charge_utile?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.type_camion?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.ordre?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()))
    );

  const filteredCamionsPaysDestinationEntrants = (categorie) =>
    camionsPaysDestinationEntrantsParCategorie(categorie).filter(camion =>
    (camion.tete?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      camion.queue?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      camion.immatriculation?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (camion.date_creation?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.charge_utile?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.type_camion?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.ordre?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()))
    );

  // Camions sortants par catégorie avec recherche
  const filteredCamionsSortantsNationaux = (categorie) =>
    camionsNationauxSortantsParCategorie(categorie).filter(camion =>
    (camion.tete__numero_immatriculation?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      camion.queue__numero_immatriculation?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      camion.immatriculation?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (camion.date_creation?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.charge_utile?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.type_camion?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.ordre?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.lot_ref?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()))
    );

  const filteredCamionsSortantsPaysDestination = (categorie) =>
    camionsPaysDestinationSortantsParCategorie(categorie).filter(camion =>
    (camion.tete__numero_immatriculation?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      camion.queue__numero_immatriculation?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      camion.immatriculation?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (camion.date_creation?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.charge_utile?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.type_camion?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.ordre?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()) ||
      (camion.lot_ref?.toString().toLowerCase() || "").includes(searchTerm.toLowerCase()))
    );

  // Découpage des données pour pagination
  const paginatedCamionsNationauxEntrants = (categorie) => {
    const filtered = filteredCamionsNationauxEntrants(categorie);
    const pageInfo = currentPages?.entrants[categorie] || { nationaux: 0, pays_destination: 0 };
    return filtered.slice(
      pageInfo.nationaux * nbParPage,
      (pageInfo.nationaux + 1) * nbParPage
    );
  };

  const paginatedCamionsPaysDestinationEntrants = (categorie) => {
    const filtered = filteredCamionsPaysDestinationEntrants(categorie);
    const pageInfo = currentPages?.entrants[categorie] || { nationaux: 0, pays_destination: 0 };
    return filtered.slice(
      pageInfo.pays_destination * nbParPage,
      (pageInfo.pays_destination + 1) * nbParPage
    );
  };

  const paginatedCamionsSortantsNationaux = (categorie) => {
    const filtered = filteredCamionsSortantsNationaux(categorie);
    const pageInfo = currentPages?.sortants[categorie] || { nationaux: 0, pays_destination: 0 };
    return filtered.slice(
      pageInfo.nationaux * nbParPage,
      (pageInfo.nationaux + 1) * nbParPage
    );
  };

  const paginatedCamionsSortantsPaysDestination = (categorie) => {
    const filtered = filteredCamionsSortantsPaysDestination(categorie);
    const pageInfo = currentPages.sortants[categorie] || { nationaux: 0, pays_destination: 0 };
    return filtered.slice(
      pageInfo.pays_destination * nbParPage,
      (pageInfo.pays_destination + 1) * nbParPage
    );
  };

  // Récupération des paramètres depuis le backend
  const fetchParametres = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_HOTE}/info-parametres-notifications/`
      );
      if (!response.ok)
        throw new Error("Erreur lors de la récupération des paramètres");
      const result = await response.json();
      if (result.success && result.data) {
        setItemsPerPage(result.data.nombre_elements_par_page || 5);
        setPageDuration(result.data.duree_affichage_page || 5);
      }
    } catch (error) {
      console.error("Erreur lors du fetch des paramètres :", error);
    }
  };

  // Défilement automatique pour chaque liste
  useEffect(() => {
    if (searchTerm || isPaused) return; // Stop le carrousel si recherche en cours

    const intervals = {};

    // Pour chaque catégorie, gérer le défilement
    allCategories.forEach(cat => {
      const categorie = cat.nom_categorie;

      // ENTRANTS
      const totalPagesNationauxEntrants = Math.ceil(filteredCamionsNationauxEntrants(categorie).length / nbParPage);
      const totalPagesPaysDestEntrants = Math.ceil(filteredCamionsPaysDestinationEntrants(categorie).length / nbParPage);

      if (totalPagesNationauxEntrants > 1) {
        intervals[`entrantsNationaux-${categorie}`] = setInterval(() => {
          setCurrentPages(prev => ({
            ...prev,
            entrants: {
              ...prev.entrants,
              [categorie]: {
                ...prev.entrants[categorie],
                nationaux: ((prev.entrants[categorie]?.nationaux || 0) + 1) % totalPagesNationauxEntrants
              }
            }
          }));
        }, dureeAffichage);
      }

      if (totalPagesPaysDestEntrants > 1) {
        intervals[`entrantsPaysDest-${categorie}`] = setInterval(() => {
          setCurrentPages(prev => ({
            ...prev,
            entrants: {
              ...prev.entrants,
              [categorie]: {
                ...prev.entrants[categorie],
                pays_destination: ((prev.entrants[categorie]?.pays_destination || 0) + 1) % totalPagesPaysDestEntrants
              }
            }
          }));
        }, dureeAffichage);
      }

      // SORTANTS
      const totalPagesNationauxSortants = Math.ceil(filteredCamionsSortantsNationaux(categorie).length / nbParPage);
      const totalPagesPaysDestSortants = Math.ceil(filteredCamionsSortantsPaysDestination(categorie).length / nbParPage);

      if (totalPagesNationauxSortants > 1) {
        intervals[`sortantsNationaux-${categorie}`] = setInterval(() => {
          setCurrentPages(prev => ({
            ...prev,
            sortants: {
              ...prev.sortants,
              [categorie]: {
                ...prev.sortants[categorie],
                nationaux: ((prev.sortants[categorie]?.nationaux || 0) + 1) % totalPagesNationauxSortants
              }
            }
          }));
        }, dureeAffichage);
      }

      if (totalPagesPaysDestSortants > 1) {
        intervals[`sortantsPaysDest-${categorie}`] = setInterval(() => {
          setCurrentPages(prev => ({
            ...prev,
            sortants: {
              ...prev.sortants,
              [categorie]: {
                ...prev.sortants[categorie],
                pays_destination: ((prev.sortants[categorie]?.pays_destination || 0) + 1) % totalPagesPaysDestSortants
              }
            }
          }));
        }, dureeAffichage);
      }
    });

    return () => Object.values(intervals).forEach(clearInterval);
  }, [
    nbParPage,
    dureeAffichage,
    searchTerm,
    isPaused,
    allCategories
  ]);

  // // Récupération des camions entrants
  // const fetchCamionsPaysDestination = async () => {
  //   try {
  //     setIsLoading(true);
  //     const response = await fetch(
  //       `${process.env.REACT_APP_HOTE}/liste-camions-ecran-inter/${parc_ref}/`
  //     );
  //     const data = await response.json();

  //     const camionsTries = (data.camions || []).sort(
  //       (a, b) => a.ordre - b.ordre
  //     );

  //     const camionsAvecRang = camionsTries.map((camion, index) => ({
  //       ...camion,
  //       rang: index + 1,
  //     }));

  //     setCamions(camionsAvecRang);
  //   } catch (error) {
  //     console.error("Erreur réseau:", error);
  //     setCamions([]);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  // // Récupération des camions sortants
  // const fetchCamionsSortantsPaysDestination = async () => {
  //   try {
  //     setIsLoading(true);
  //     const response = await fetch(
  //       `${process.env.REACT_APP_HOTE}/liste-camions-sortants-ecran-inter/${parc_ref}/`
  //     );
  //     const data = await response.json();

  //     const camionsTries = (data.camions || []).sort((a, b) => a.ordre - b.ordre);

  //     const camionsAvecRang = camionsTries.map((camion, index) => ({
  //       ...camion,
  //       rang: index + 1,
  //     }));

  //     setCamionsSortants({
  //       nationaux: camionsAvecRang.filter(isBeninois),
  //       pays_destination: camionsAvecRang.filter((camion) => !isBeninois(camion)),
  //     });
  //   } catch (error) {
  //     console.error("Erreur réseau:", error);
  //     setCamionsSortants({ nationaux: [], pays_destination: [] });
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };


  // Formatage de date
  const formatDate = (datetime) => {
    if (!datetime) return "";
    const date = new Date(datetime);
    return date.toLocaleDateString("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  useEffect(() => {
    if (!parc_ref) return;

    let evtSource;
    let reconnectTimer;
    const RECONNECT_DELAY = 5000;

    const connect = () => {
      evtSource = new EventSource(`${process.env.REACT_APP_HOTE}/camions-internationaux-stream/${parc_ref}/`);

      evtSource.onopen = () => console.log("SSE ouverte :", evtSource.url);

      // 🔹 Écoute spécifique pour les camions entrants
      evtSource.addEventListener("entrants", (e) => {
        try {
          const camions = JSON.parse(e.data);

          setCamions(camions); // remplacer toute la liste d’entrants
        } catch (err) {
          console.error("Erreur parsing SSE entrants :", err);
        }
      });

      // 🔹 Écoute spécifique pour les camions sortants
      evtSource.addEventListener("sortants", (e) => {
        try {
          const camions = JSON.parse(e.data);

          // Mise à jour de la structure nationaux / pays_destination
          setCamionsSortants(prev => {
            const nationaux = camions.filter(c => isBeninois(c)).sort((a, b) => a.ordre - b.ordre);
            const pays_destination = camions.filter(c => !isBeninois(c)).sort((a, b) => a.ordre - b.ordre);
            return { nationaux, pays_destination };
          });

        } catch (err) {
          console.error("Erreur parsing SSE sortants :", err);
        }
      });

      // 🔹 Écoute pour suppression
      evtSource.addEventListener("delete", (e) => {
        const deletedId = parseInt(e.data, 10);
        setCamions(prev => prev.filter(c => c.id !== deletedId));
        setCamionsSortants(prev => ({
          nationaux: prev.nationaux.filter(c => c.id !== deletedId),
          pays_destination: prev.pays_destination.filter(c => c.id !== deletedId)
        }));
      });

      evtSource.onerror = (err) => {
        console.error("⚠️ SSE erreur :", err);
        evtSource.close();
        if (!reconnectTimer) {
          reconnectTimer = setTimeout(() => {
            reconnectTimer = null;
            connect();
          }, RECONNECT_DELAY);
        }
      };
    };

    connect();

    return () => {
      if (evtSource) evtSource.close();
      if (reconnectTimer) clearTimeout(reconnectTimer);
    };
  }, [parc_ref]);


  useEffect(() => {
    fetchParametres();

    const intervalId = setInterval(fetchParametres, dureeAffichage);

    return () => clearInterval(intervalId);
  }, []);

  const CamionEntrantCard = ({ camion, index, isMobile, isTablet }) => {
    const shouldWrapDate = isMobile || isTablet || true;

    return (
      <motion.div
        key={`${camion.id || index}-${currentPages.entrants}`}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.3 }}
        style={{
          padding: "8px 10px",
          marginBottom: "8px",
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
          borderLeft: "3px solid #3498db",
          maxWidth: "400px",  // largeur max
          fontSize: "0.8rem",
          width: "100%",       // occupe toute la largeur du conteneur
          boxSizing: "border-box",
        }}
      >
        {/* Ligne 1 - Rang + Immatriculation + Date */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",  // espace régulier entre badges
            marginBottom: "8px"
          }}
        >
          {/* Rang */}
          <div
            style={{
              width: "auto",
              padding: "0 4px",
              height: "24px",
              backgroundColor: "#f1f5f9",
              borderRadius: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "600",
              fontSize: "0.8rem",
              flexShrink: 0,
            }}
          >
            {camion.ordre}
          </div>

          {/* Immatriculation */}
          <div
            style={{
              fontWeight: "500",
              flex: isTablet ? "0 1 auto" : 1,
              minWidth: isMobile ? "calc(100% - 34px)" : "100px",
              // whiteSpace: "nowrap",
              // overflow: "hidden",
              // textOverflow: "ellipsis",
            }}
          >
            {camion.atellage === '1'
              ? `${camion.tete} + ${camion.queue}`
              : camion.immatriculation || 'Non spécifié'}
          </div>

          {/* Date */}
          <div
            style={{
              color: "#7f8c8d",
              flexShrink: 0,
              ...(isMobile && {
                flexBasis: "100%",
              }),
              ...(isTablet && {
                marginLeft: "auto",
              }),
            }}
          >
            <span>Entré: </span>
            <span>
              {camion.date_creation ? formatDate(camion.date_creation) : "-"}
            </span>
          </div>
        </div>

        {/* Ligne 2 - Charge utile, Parc */}
        <div style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",  // espace régulier entre badges
          marginBottom: "8px"
        }}>
          <span style={{
            fontSize: "11px",
            fontWeight: "600",
            color: "#3b82f6",
            padding: "4px 8px",
            backgroundColor: "#eff6ff",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            borderRadius: "10px"
          }}>
            <FaWeightHanging size={12} color="#f59e0b" />
            Charge utile: {camion.charge_utile || "-"} kg
          </span>

          <span style={{
            fontSize: "11px",
            fontWeight: "600",
            padding: "4px 8px",
            backgroundColor: "#eff6ff",
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            gap: "4px",
            color: "#92400e",
          }}>
            <BsCarFront size={12} color="#ef4444" />
            {camion.type_camion || "-"}
          </span>
        </div>
      </motion.div>
    );
  };


  const CamionSortantCard = ({ camion, index, type, isMobile, isTablet }) => {
    const shouldWrapDate = isMobile || isTablet || true;
    return (
      <motion.div
        key={`${camion.id || index}-${currentPages[type]}`}
        initial={{ opacity: 0, y: 10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.3 }}
        style={{
          borderLeft: `3px solid ${type === "nationaux"
            ? "#3498db"
            : type === "pays_destination"
              ? "#2ecc71"
              : "#9b59b6"
            }`,

          padding: "8px 10px",
          marginBottom: "8px",
          backgroundColor: "#fff",
          borderRadius: "8px",
          boxShadow: "0 1px 2px rgba(0,0,0,0.1)",
          borderLeft: "3px solid #3498db",
          maxWidth: "400px",  // largeur max
          fontSize: "0.8rem",
          width: "100%",       // occupe toute la largeur du conteneur
          boxSizing: "border-box",

        }}
      >
        {/* Ligne 1 - Rang + Immatriculation + Date */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",  // espace régulier entre badges
            marginBottom: "8px"
          }}
        >
          {/* Rang */}
          <div
            style={{
              width: "auto",
              padding: "0 4px",
              height: "24px",
              backgroundColor: "#f1f5f9",
              borderRadius: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontWeight: "600",
              fontSize: "0.8rem",
              flexShrink: 0,
            }}
          >
            {/* {index + 1 + currentPages[type] * nbParPage} */}
            {camion.ordre || index + 1 + currentPages[type] * nbParPage}
          </div>

          {/* Immatriculation */}
          <div
            style={{
              fontWeight: "500",
              flex: isTablet ? "0 1 auto" : 1,
              // flex: isTablet ? "0 1 auto" : (shouldWrapDate ? "1 0 100%" : 1),
              minWidth: isMobile ? "calc(100% - 34px)" : "100px",
              // whiteSpace: "nowrap",
              // overflow: "hidden",
              // textOverflow: "ellipsis",
              // marginRight: shouldWrapDate ? 0 : "10px"
            }}
          >
            {camion.atellage === '1'
              ? `${camion.tete} + ${camion.queue}`
              : camion.immatriculation || 'Non spécifié'}
          </div>

          {/* Date */}
          {/* <div
            style={{
              color: "#7f8c8d",
              flexShrink: 0,
              ...(isMobile && {
                flexBasis: "100%",
              }),
              ...(isTablet && {
                marginLeft: "auto",
              }),
              // flexBasis: shouldWrapDate ? "100%" : "auto",
              // marginLeft: shouldWrapDate ? "34px" : "auto",
              // marginTop: shouldWrapDate ? "8px" : 0
            }}
          >
            <span>Sorti: </span>
            <span>
              {camion.date_sortie_reele
                ? formatDate(camion.date_sortie_reele)
                : "-"}
            </span>
          </div> */}
        </div>

        {/* Ligne 2 - Charge utile, Parc */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",      // espace régulier entre badges
            marginBottom: "8px"
          }}
        >
          {/* Charge utile */}
          <span
            style={{
              fontSize: "11px",
              fontWeight: "600",
              padding: "4px 8px",
              backgroundColor: "#eff6ff",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              gap: "4px",
              color: "#3b82f6",
            }}
          >
            <FaWeightHanging size={12} color="#f59e0b" />
            Charge utile: {camion.charge_utile || "-"} kg
          </span>

          {/* Type camion */}
          <span
            style={{
              fontSize: "11px",
              fontWeight: "600",
              padding: "4px 8px",
              backgroundColor: "#eff6ff",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              gap: "4px",
              color: "#92400e",
            }}
          >
            <BsCarFront size={12} color="#ef4444" />
            {camion.type_camion || "-"}
          </span>
        </div>

        {/* Ligne 3 - Type, Lot */}
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "10px",
            marginBottom: "8px"
          }}
        >
          {/* Lot */}
          <span
            style={{
              fontSize: "11px",
              fontWeight: "600",
              padding: "4px 8px",
              backgroundColor: "#eff6ff",
              borderRadius: "10px",
              display: "flex",
              alignItems: "center",
              gap: "4px",
              color: "#7f8c8d",
            }}
          >
            <FaBoxOpen size={12} color="#10b981" />
            Lot: {camion.lot_ref || "-"}
          </span>
        </div>

      </motion.div>
    );
  };

  // Initialisation au montage
  useEffect(() => {
    fetchParametres();
    // fetchCamionsPaysDestination();
    // fetchCamionsSortantsPaysDestination();
    fetchCategories();
    fetchParcs();
  }, []);

  // Trouver le parc correspondant à parc_ref
  const parc = parcs.find((p) => p.ref_parc === parc_ref);

  // Détection de la taille de l'écran
  // useEffect(() => {
  //   const checkScreenSize = () => {
  //     const width = window.innerWidth;
  //     setIsMobileView(width < 992); // Tablette et smartphone
  //   };

  //   checkScreenSize();
  //   window.addEventListener("resize", checkScreenSize);
  //   return () => window.removeEventListener("resize", checkScreenSize);
  // }, []);
  const isMobile = useMediaQuery({ maxWidth: 767 });
  const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 });
  const isDesktop = useMediaQuery({ minWidth: 992 });

  // Calcul de isMobileView pour la compatibilité avec le code existant
  const isMobileView = isMobile || isTablet;


  // --- Regroupement par catégorie pour chacun des 4 blocs ---
  // On extrait toutes les catégories uniques des 4 listes
  const categories = Array.from(
    new Set([
      ...camionsNationauxEntrants.map((c) => c.categorie),
      ...camionsPaysDestinationEntrants.map((c) => c.categorie),
      ...camionsNationauxSortants.map((c) => c.categorie),
      ...camionsPaysDestinationSortants.map((c) => c.categorie),
    ])
  ).filter(Boolean);
  // État pour la page actuelle par catégorie
  const [currentPagesParCategorie, setCurrentPagesParCategorie] = useState({});
  // Déterminer si on est en mode recherche
  const isSearching = searchTerm.trim() !== "";

  // On crée une structure regroupée par catégorie
  // const camionsParCategorie = allCategories.map((cat) => {
  //   const categorie = cat.nom_categorie || cat.categorie; // Essayez les deux possibilités
  //   const nationauxEntrants = filteredCamionsNationauxEntrants(categorie);
  //   const destinationEntrants = filteredCamionsPaysDestinationEntrants(categorie);
  //   const nationauxSortants = filteredCamionsSortantsNationaux(categorie);
  //   const destinationSortants = filteredCamionsSortantsPaysDestination(categorie);

  //   return {
  //     categorie,
  //     nationauxEntrants,
  //     destinationEntrants,
  //     nationauxSortants,
  //     destinationSortants,
  //   };
  // })
  //   .filter((cat) => !isSearching ||
  //     (cat.nationauxEntrants && cat.nationauxEntrants.length > 0) ||
  //     (cat.destinationEntrants && cat.destinationEntrants.length > 0) ||
  //     (cat.nationauxSortants && cat.nationauxSortants.length > 0) ||
  //     (cat.destinationSortants && cat.destinationSortants.length > 0)
  //   );

  const camionsParCategorie = allCategories.filter((cat) =>
    selectedCategorie ? cat.nom_categorie === selectedCategorie : true
  ).map((cat) => {
    const categorie = cat.nom_categorie || cat.categorie || "Inconnue";
    return {
      categorie,
      nationauxEntrants: filteredCamionsNationauxEntrants(categorie) || [],
      destinationEntrants: filteredCamionsPaysDestinationEntrants(categorie) || [],
      nationauxSortants: filteredCamionsSortantsNationaux(categorie) || [],
      destinationSortants: filteredCamionsSortantsPaysDestination(categorie) || [],
    };
  }).filter(cat =>
    !isSearching ||
    cat.nationauxEntrants.length > 0 ||
    cat.destinationEntrants.length > 0 ||
    cat.nationauxSortants.length > 0 ||
    cat.destinationSortants.length > 0
  )
    // 🔥 Tri : catégories avec données d’abord
    .sort((a, b) => {
      const aHasData =
        a.nationauxEntrants.length > 0 ||
          a.destinationEntrants.length > 0 ||
          a.nationauxSortants.length > 0 ||
          a.destinationSortants.length > 0
          ? 1
          : 0;

      const bHasData =
        b.nationauxEntrants.length > 0 ||
          b.destinationEntrants.length > 0 ||
          b.nationauxSortants.length > 0 ||
          b.destinationSortants.length > 0
          ? 1
          : 0;

      return bHasData - aHasData; // celles avec données en premier
    });


  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setCurrentPages(prev => {
      const entrants = { ...(prev?.entrants || {}) };
      const sortants = { ...(prev?.sortants || {}) };
      Object.keys(entrants).forEach(k => entrants[k] = { nationaux: 0, pays_destination: 0 });
      Object.keys(sortants).forEach(k => sortants[k] = { nationaux: 0, pays_destination: 0 });
      return { entrants, sortants };
    });
    setCurrentCategorieIndex(0);
  };


  // Index de la catégorie active
  const dureeAffichageCategories = 3000; // durée d’affichage par catégorie
  const [currentCategorieIndex, setCurrentCategorieIndex] = useState(0);

  useEffect(() => {
    if (camionsParCategorie.length > 1 && !searchTerm && !isPaused && !selectedCategorie) {
      const interval = setInterval(() => {
        setCurrentCategorieIndex(
          (prev) => (prev + 1) % camionsParCategorie.length
        );
      }, dureeAffichageCategories);
      return () => clearInterval(interval);
    }
  }, [camionsParCategorie.length, searchTerm, dureeAffichageCategories, isPaused, selectedCategorie]);

  // Récupérer les deux catégories actives à afficher
  const categorieActive = camionsParCategorie.slice(
    currentCategorieIndex,
    currentCategorieIndex + 1
  );

  // Si on atteint la fin du tableau, on peut compléter avec les premières catégories pour boucler
  if (categorieActive.length < 1 && camionsParCategorie.length > 0) {
    categorieActive.push(...camionsParCategorie.slice(0, 1 - categorieActive.length));
  }

  useEffect(() => {
    if (allCategories?.length) {
      const initPages = {
        entrants: {},
        sortants: {}
      };

      allCategories.forEach(cat => {
        const categorie = cat.nom_categorie || cat.categorie;
        initPages.entrants[categorie] = { nationaux: 0, pays_destination: 0 };
        initPages.sortants[categorie] = { nationaux: 0, pays_destination: 0 };
      });

      setCurrentPages(initPages);
    }
  }, [allCategories]);


  useEffect(() => {
    console.log("Camions entrants:", camions);
    console.log("Camions sortants:", camionsSortants);
    console.log("Toutes les catégories:", allCategories);
  }, [camions, camionsSortants, allCategories]);

  const CamionsBloc = ({ camionsNationaux, camionsDestination, currentPage, isMobile, isTablet, titre, type }) => (
    <div
      style={{
        borderRadius: "8px",
        padding: "15px",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
      }}
    >
      <div
        style={{
          textAlign: "center",
          padding: "12px 14px",
          backgroundColor: "#f8f9fa",
          borderBottom: "1px solid #e9ecef",
        }}
      >
        <h3 style={{ color: "#2c3e50", margin: 0 }}>{titre}</h3>
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr",
          gap: "15px",
          padding: "8px",
        }}
      >
        {/* Nationaux */}
        <div
          style={{
            backgroundColor: "#e3f2fd",
            borderRadius: "6px",
            overflow: "hidden",
          }}
        >
          <h4 style={{ textAlign: "center", padding: "10px", margin: 0, color: "#0d47a1" }}>
            Nationaux
          </h4>
          <div style={{ padding: "10px" }}>
            <AnimatePresence mode="wait">
              {Array.isArray(camionsNationaux) && camionsNationaux.length > 0 ? (
                camionsNationaux.map((camion, idx) =>
                  type === "entrants" ? (
                    <CamionEntrantCard
                      key={`nationaux-${camion.id}-${currentPage.nationaux}`}
                      camion={camion}
                      index={idx}
                      isMobile={isMobile}
                      isTablet={isTablet}
                    />
                  ) : (
                    <CamionSortantCard
                      key={`nationaux-${camion.id}-${currentPage.nationaux}`}
                      camion={camion}
                      index={idx}
                      type="nationaux"
                      isMobile={isMobile}
                      isTablet={isTablet}
                    />
                  )
                )
              ) : (
                <p style={{ textAlign: "center", color: "#555", fontStyle: "italic" }}>
                  Aucun camion national {type}
                </p>
              )}
            </AnimatePresence>
          </div>
        </div>

        {/* Pays Destination */}
        <div
          style={{
            backgroundColor: "#e8f5e9",
            borderRadius: "6px",
            overflow: "hidden",
          }}
        >
          <h4 style={{ textAlign: "center", padding: "10px", margin: 0, color: "#2e7d32" }}>
            Pays Destination
          </h4>
          <div style={{ padding: "10px" }}>
            <AnimatePresence mode="wait">
              {Array.isArray(camionsDestination) && camionsDestination.length > 0 ? (
                camionsDestination.map((camion, idx) =>
                  type === "entrants" ? (
                    <CamionEntrantCard
                      key={`destination-${camion.id}-${currentPage.pays_destination}`}
                      camion={camion}
                      index={idx}
                      isMobile={isMobile}
                      isTablet={isTablet}
                    />
                  ) : (
                    <CamionSortantCard
                      key={`destination-${camion.id}-${currentPage.pays_destination}`}
                      camion={camion}
                      index={idx}
                      type="pays_destination"
                      isMobile={isMobile}
                      isTablet={isTablet}
                    />
                  )
                )
              ) : (
                <p style={{ textAlign: "center", color: "#555", fontStyle: "italic" }}>
                  Aucun camion destination {type}
                </p>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );

  // Affichage pour grand écran (structure originale avec 2 grandes cartes)
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%)",
        padding: "20px",
        display: "flex",
        flexDirection: "column"
      }}
    >
      {/* En-tête principal */}
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        style={{
          textAlign: "center",
          marginBottom: "30px"
        }}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "12px" }}>
          <FaShip size={28} color="#3b82f6" />
          <h1 style={{
            fontSize: "32px",
            fontWeight: "700",
            color: "#1e293b",
            letterSpacing: "-0.02em",
            margin: 0
          }}>
            {parc ? parc.nom_parc : "Parc introuvable"}
          </h1>
        </div>
        <p style={{ color: "#64748b", fontSize: "14px", marginTop: "8px" }}>
          Affichage en temps réel des camions par catégorie
        </p>
      </motion.div>

      {/* <SearchBar /> */}
      {(isMobile || isTablet) && (
        <div
          style={{
            margin: "0 0 20px 0",
            padding: "0 10px",
            width: "100%",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column", // ✅ Toujours en colonne
              alignItems: "stretch",
              gap: "10px",
              width: "100%",
              maxWidth: "600px",
              margin: "0 auto",
            }}
          >
            {/* Champ recherche */}
            <div style={{ position: "relative", width: "100%" }}>
              <input
                type="text"
                placeholder="Rechercher immatriculation..."
                value={searchTerm}
                onChange={handleSearchChange}
                onFocus={() => {
                  setCurrentPages((prev) => {
                    const entrants = { ...(prev?.entrants || {}) };
                    const sortants = { ...(prev?.sortants || {}) };
                    Object.keys(entrants).forEach((k) => {
                      entrants[k] = { nationaux: 0, pays_destination: 0 };
                    });
                    Object.keys(sortants).forEach((k) => {
                      sortants[k] = { nationaux: 0, pays_destination: 0 };
                    });
                    return { entrants, sortants };
                  });
                }}
                style={{
                  width: "100%",
                  padding: "12px 15px",
                  borderRadius: "6px",
                  border: "1px solid #3498db",
                  fontSize: "14px",
                  fontFamily: "inherit",
                  boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                }}
              />
              {searchTerm && (
                <button
                  onClick={() => setSearchTerm("")}
                  style={{
                    position: "absolute",
                    right: "12px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    background: "transparent",
                    border: "none",
                    fontSize: "18px",
                    cursor: "pointer",
                    color: "#7f8c8d",
                  }}
                >
                  ×
                </button>
              )}
            </div>

            {/* Filtre catégories */}
            <select
              value={selectedCategorie || ""}
              onChange={(e) => setSelectedCategorie(e.target.value || null)}
              style={{
                width: "100%", // ✅ prend toute la largeur
                padding: "12px 15px",
                borderRadius: "6px",
                border: "1px solid #3498db",
                fontSize: "14px",
                fontFamily: "inherit",
              }}
            >
              <option value="">Toutes les catégories</option>
              {allCategories.map((parc) => (
                <option key={parc.ref_parc} value={parc.nom_categorie}>
                  {parc.nom_categorie}
                </option>
              ))}
            </select>
          </div>
        </div>

      )}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: isMobile ? "1fr" : "1fr", // 1 catégorie par ligne sur mobile/tablette
          gap: "20px",
          marginBottom: "20px",
          justifyContent: "center"
        }}
        // onMouseEnter={() => setIsPaused(true)}
        // onMouseLeave={() => setIsPaused(false)}
        onTouchStart={() => setIsPaused(true)}
        onTouchEnd={() => setIsPaused(false)}
      >
        {categorieActive.map((categorie, idx) => (
          <div
            key={categorie.categorie || idx}
            style={{
              background: "#fff",
              borderRadius: "8px",
              padding: "12px",
            }}
          >
            {/* Titre Catégorie */}
            <div
              style={{
                textAlign: "center",
                marginBottom: "20px",
                padding: "20px",
                backgroundColor: "#3b82f6",
                color: "white",
                borderRadius: "12px",
                margin: "-12px -12px 12px -12px",
                zIndex: 10,
                position: "relative"
              }}
            >
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                <FaLayerGroup size={16} />
                <span style={{ fontSize: "16px", fontWeight: "600" }}>
                  {categorie.categorie}
                </span>
              </div>
            </div>

            {/* Blocs ENTRANTS et SORTANTS */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: isMobile ? "1fr" : "1fr 1fr", // Mobile : empilé, tablette/desktop : côte à côte
                gap: "20px",
              }}
            >
              {/* ENTRANTS */}
              <CamionsBloc
                camionsNationaux={paginatedCamionsNationauxEntrants(categorie.categorie)}
                camionsDestination={paginatedCamionsPaysDestinationEntrants(categorie.categorie)}
                currentPage={currentPages.entrants[categorie.categorie] || { nationaux: 0, pays_destination: 0 }}
                isMobile={isMobile}
                isTablet={isTablet}
                titre="Camions entrants"
                type="entrants"
              />

              {/* SORTANTS */}
              <CamionsBloc
                camionsNationaux={paginatedCamionsSortantsNationaux(categorie.categorie)}
                camionsDestination={paginatedCamionsSortantsPaysDestination(categorie.categorie)}
                currentPage={currentPages.sortants[categorie.categorie] || { nationaux: 0, pays_destination: 0 }}
                isMobile={isMobile}
                isTablet={isTablet}
                titre="Camions sortants"
                type="sortants"
              />
            </div>
          </div>
        ))}
      </div>

    </div>
  );
};

export default Liste_pays_destination;
